import { z } from 'zod'

/**
 * Whether a tenant can use PixelSign. Mirrors `TenantStatus` in
 * `api/prisma/schema.prisma`. A suspended tenant's API keys are refused and its
 * dashboard is read-only; envelopes already in flight still finish. A closed
 * tenant has left: keys revoked, open envelopes voided, members locked out,
 * and its files purged after `TENANT_PURGE_AFTER_DAYS`.
 */
export const TENANT_STATUSES = ['active', 'suspended', 'closed'] as const

/** Days a closed tenant's envelope files are kept (for staff to hand over copies) before they're purged. */
export const TENANT_PURGE_AFTER_DAYS = 90

export const tenantStatusSchema = z.enum(TENANT_STATUSES)

export type TenantStatus = z.infer<typeof tenantStatusSchema>

export const PRISMA_TENANT_STATUSES = ['ACTIVE', 'SUSPENDED', 'CLOSED'] as const

export type PrismaTenantStatus = (typeof PRISMA_TENANT_STATUSES)[number]

export const TENANT_STATUS_FROM_PRISMA = {
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CLOSED: 'closed',
} as const satisfies Record<PrismaTenantStatus, TenantStatus>

export const TENANT_STATUS_TO_PRISMA = {
  active: 'ACTIVE',
  suspended: 'SUSPENDED',
  closed: 'CLOSED',
} as const satisfies Record<TenantStatus, PrismaTenantStatus>
